import React, { Component } from "react";
import style from "./list.module.sass";
import { Table, Icon, Spin } from "antd";
import { Button, Modal } from '../../../../helpers/commonUi'
import { pushToast } from '../../../../stateManager/store/toast/actions'
import moment from 'moment'

import Form from "./Form";
import { connect } from "react-redux";
import { deleteForm } from "../../../../stateManager/store/forms/action";
import { Http } from "../../../../helpers/axois";

import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import { ReactComponent as Acl } from '../../../../assets/svg/acl.svg'
import formImg from '../../../../assets/images/create_form.svg';
import NoData from '../../NoData'
import { AppState } from "../../../../stateManager/store";
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import AclFormDrawer from "../../Assisted/forms/create/AclFormDrawer";
import { updateFormCoreVersion } from "../../../../stateManager/store/apps/actions";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface State {
  visible: boolean;
  editInitialData?: {};
  formsList?: any[];
  editable: boolean;
  editvisible?: boolean;
  loading?: boolean;
  deleteVisible: boolean;
  deleteData: any;
  appId: string;
  aclDrawerVisible?:any;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

interface Props {
  match?: any;
  app?: any;
  history?: any;
  deleteForm: (data: any) => void;
  appVersion?: { currentVersion: boolean, versionId: string };
  pushToast: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
  currentBranch?: any;
  updateFormCoreVersion?: any;
}

class FormsList extends Component<Props, State> {


  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editable: false,
      formsList: [],
      editvisible: false,
      loading: false,
      deleteVisible: false,
      deleteData: {},
      appId: this.props.match.params.appId,
      aclDrawerVisible:false,
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef()
    }
  }


  componentDidMount() {
    this.versionUpdate(this.props);
  }

  getForms(versionId: string) {
    this.state.searchRef.current?.clearSearch()
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.state.appId] && this.props.currentBranch[this.state.appId].branchId
    this.setState({
      loading: true
    })
    // const version = this.props.appVersion && this.props.appVersion.versionId
    Http.get(`/apps/${this.state.appId}/forms?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((formRes: any) => {
      this.setState({
        formsList: formRes,
        filteredData: formRes,
        loading: false
      })
    }, (err) => {
      if (err !== 'Forbidden') {
        this.setState({
          formsList: [],
          filteredData: [],
          loading: false
        })
        this.props.pushToast(
          { type: 'error', message: (err && err.message) ? err.message : "Form Getting failed" }
        )
      }
    });
  }


  componentWillReceiveProps(props: Props) {
    if (props.appVersion && this.props.appVersion &&
      (props.appVersion.versionId !== this.props.appVersion.versionId)) {

      this.setState({
        appId: props.match.params.appId
      }, () => this.versionUpdate(props))
    }
  }

  versionUpdate(props: Props) {
    const version = props.appVersion;
    if (version) {
      this.getForms(version.versionId)
    }
  }

  deleteForms(formId: string) {
    const appId = this.props.match.params.appId
    const version: any = this.props.appVersion && this.props.appVersion.versionId
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
    this.setState({
      loading: true
    })
    Http.delete(`/forms/${formId}?appId=${appId}&versionId=${version}&branchId=${currentBranchId}`).subscribe((res) => {
      this.props.pushToast(
        { type: 'success', message: 'Form deleted successfully' }
      )
      this.getForms(version);
      this.setState({
        loading: false
      })
    }, (err) => {
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : "Form deletion failed" }
      )
      this.setState({
        loading: false
      })
    })
  }

  render() {
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion
    const canCreateForm = currentVersion && (this.props.orgPermissions.includes('forms.Create') || this.props.appPermissions.includes('forms.Create'))
    const canEditForm = currentVersion && (this.props.orgPermissions.includes('forms.Edit') || this.props.appPermissions.includes('forms.Edit'))
    const canDeleteForm = currentVersion && (this.props.orgPermissions.includes('forms.Delete') || this.props.appPermissions.includes('forms.Delete'))
    const canViewForm = (this.props.orgPermissions && this.props.orgPermissions.includes('forms.View')) || (this.props.appPermissions && this.props.appPermissions.includes('forms.View'))

    const columns: any = [
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Name(Identifier)",
        dataIndex: "formName",
        key: "formName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Org Name",
        dataIndex: "orgName",
        key: "orgName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Created By",
        dataIndex: "createdByName",
        key: "createdByName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Updated At",
        dataIndex: "updatedat",
        key: "updatedat",
        render: (text: string) => {
          let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
          formattedValue = highlightMatch(formattedValue, this.state.searchValue)
          return formattedValue
        }
      }
    ];

    if (currentVersion) {
      columns.push(
        {
          title: "Action",
          key: "action",
          render: (text: any, record: any) => (
            <span className="action action_grp">
              <span  data-test-id="action_edit"
                style={{margin:0}}
                title="Policy"
                className="action-icon edit-icon"
                onClick={e => {
                  e.stopPropagation();
                  if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                    this.props.pushToast({
                      type: 'error',
                      message: 'Cannot modify a previous app version'
                    })
                    return
                  }
                  this.setState({ aclDrawerVisible: true,editInitialData: record})
                }}
              >
                <Acl  style={{width:"15px",height:"15px"}}/>
              </span>
              <span
                data-test-id="action_edit"
                className="action-icon edit-icon"
                title="Edit"
                onClick={e => {
                  e.stopPropagation();
                  if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                    this.props.pushToast({
                      type: 'error',
                      message: 'Cannot modify a previous app version'
                    })
                    return
                  }
                  if (canEditForm) {
                    this.setState({
                      editvisible: true,
                      editInitialData: record,
                      editable: true
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this form'
                    })
                  }
                }}
              >
                <TableEdit  style={{width:"15px",height:"15px"}} />
              </span>
              {this.state.formsList!.length >= 1 && (
                <span
                  data-test-id="action_delete"
                  className="action-icon delete-icon"
                  title="Delete"
                  onClick={e => {
                    e.stopPropagation();
                    if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                      this.props.pushToast({
                        type: 'error',
                        message: 'Cannot modify a previous app version'
                      })
                      return
                    }
                    if (canDeleteForm) {
                      this.setState({
                        deleteVisible: true,
                        deleteData: record
                      })
                    } else {
                      this.props.pushToast({
                        type: 'error',
                        message: 'You are not authorized to edit this form'
                      })
                    }
                  }}
                >
                  <Delete style={{width:"15px",height:"15px"}}/>
                </span>
              )}
            </span>
          )
        }
      )
    }

    const appId = this.props.match.params.appId
    const version: any = this.props.appVersion && this.props.appVersion.versionId;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    return (
      canViewForm ?
        <div className='viewWrapper'>
          {
            !this.state.loading && this.state.formsList && this.state.formsList.length > 0
              ?
              <div className={"row " + style.data}>
                <div className={style.header}>
                  <div className={style.first}>
                    <h4>Forms</h4>
                    <h5>View, edit or create a new form</h5>
                  </div>
                  <div className="flex">
                    <SearchBar
                      ref={this.state.searchRef}
                      data={this.state.formsList}
                      columns={columns}
                      onFilter={(filteredData ) => {
                        this.setState({
                          filteredData: filteredData,
                        })
                      }}
                      onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                    />
                    {
                      canCreateForm &&
                      (
                        <Button className={"form_create"} dataTestId="create_form" size="small" onClick={() => this.setState({ visible: true })}>
                          CREATE FORM
                        </Button>
                      )
                    }
                  </div>
                </div>
                <div className={style.content}>
                  <Table
                    pagination={false}
                    // rowSelection={{ 
                    //   type : 'checkbox',
                    //   onChange: (selectedRowKeys, selectedRows) => {
                    //   }
                    // }}
                    scroll={{ y: 'calc(100vh - 240px)' }}
                    columns={columns}
                    onRow={(record: any, rowIndex: any) => {
                      return {
                        'data-test-id': 'forms_table_row_' + record.key,
                        onClick: (event: any) => {
                          this.props.updateFormCoreVersion(record?.coreVersion);
                          const tag: any = event.target;
                          if (tag.id !== "delete") {
                            this.props.history.push(
                              "" +
                              this.props.match.url +
                              "/" +
                              record.formId +
                              "/create"
                            );
                          }
                        }
                      };
                    }}
                    className={"override-table-container"}
                    dataSource={this.state.filteredData!.map((res, key) => {
                      return { ...res, key: key };
                    })}
                  />
                </div>
              </div>
              :
              (this.state.loading)
                ?
                <div className={style.loadingSpinner}>
                  <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                </div>
                :
                <NoData
                  image={formImg}
                  header='Create Form'
                  content='Create forms for your apps'
                  // buttonText='Create new version'
                  buttonCallback={() => {
                    (canCreateForm) ? this.setState({ visible: true }) : this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to create forms'
                    });
                  }}
                  buttonClassName="form_create"
                />
          }
          <FormModal
            data-test-id="form_modal"
            visible={this.state.visible}
            getForms={() => this.getForms(version)}
            appId={appId}
            setvisible={status => this.setState({ visible: status })}
          ></FormModal>
           {
            this.state.aclDrawerVisible ? 
            <AclFormDrawer isSolo={true} getForms={() => this.getForms(version)} pushToast={this.props.pushToast} aclFormData={this.state.editInitialData} onClose={(()=>{this.setState({aclDrawerVisible: false})})}></AclFormDrawer> : null
          }
          {this.state.editvisible && (
            <FormModal
              data-test-id="edit_modal"
              getForms={() => this.getForms(version)}
              visible={this.state.editable}
              editInitialData={this.state.editInitialData}
              appId={appId}
              setvisible={status => {
                this.setState({ editable: status, editInitialData: {} });
                setTimeout(() => {
                  this.setState({ editvisible: false });
                }, 400);
              }}
              editable={this.state.editable}
            ></FormModal>
          )}
          <Modal
            id="deleteForm"
            dataTestId="delete_form"
            unmountOnCancel={true}
            visible={this.state.deleteVisible}
            title="DELETE FORM"
            onCancel={() => {
              this.setState({
                deleteVisible: false,
                deleteData: {}
              })
            }}
            // mode='Delete'
            deleteOptions={{
              type: "Form",
              validateString: this.state.deleteData.formName
            }}
            footer={{
              enable: true,
              okText: 'DELETE',
              cancelText: 'CANCEL',
              onOk: () => {
                this.deleteForms(this.state.deleteData.formId)
                this.setState({
                  deleteVisible: false,
                  searchValue: "",
                  filteredData: this?.state?.formsList || []
                })
              }
            }}
          />
        </div>
        :
        <div className="viewWrapper">
          <NoData
            data-test-id="no_data"
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access'
            noButton={true}
          />
        </div>
    );
  }
}

interface FormmodelProps {
  visible: boolean;
  getForms: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  editInitialData?: {};
  editable?: boolean;
}
let onSubmit: any;
const FormModal = ({
  visible,
  getForms,
  setvisible,
  appId,
  editInitialData,
  editable
}: FormmodelProps) => {
  return (

    <Modal
      id="createEditForm"
      dataTestId="create_edit_form"
      title={editInitialData ? 'EDIT FORM' : 'CREATE FORM'}
      visible={visible}
      onCancel={() => {
        setvisible(false);
      }}
      unmountOnCancel={true}
      footer={{
        enable: true,
        okText: editable ? "SAVE" : "CREATE",
        cancelText: "CANCEL",
        onOk: () => {
          // submit function does the submission and returns a boolean which determines whether to close the modal or not
          const shouldModalClose = onSubmit();
          setvisible(!shouldModalClose);
        }
      }}
    >
      <Form
        appId={appId}
        getForms={getForms}
        editInitialData={editInitialData}
        onSubmit={(submit: any) => (onSubmit = submit)}
        editable={editable}
      ></Form>
    </Modal>
  );
};

const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params['appId']],
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions,
    currentBranch: state.apps.appBranch
  }
};

export default connect(
  mapStateToProps,
  { deleteForm, pushToast, updateFormCoreVersion }
)(FormsList);
